module.exports = __webpack_public_path__ + "img/20190819161352145.e3602c1a.png";